export default __webpack_public_path__ + "static/media/080_finish_bad.vp9.7a751af0.webm";